import { gql } from "@apollo/client";

export const GetEmployees = gql`
  query GetEmployees {
    employeeMany {
      id
      user {
        id
        username
        role
        firstName
        middleName
        lastName
        email
        phoneNumber
        createdDate
        profilePicUrl
      }
      organization {
        id
        name
      }
    }
  }
`;

export const GetEmployeesName = gql`
  query GetEmployeesName($locationId: String, $orgId: String) {
    employeeMany(locationId: $locationId, orgId: $orgId) {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GetEmployee = gql`
  query GetEmployee($id: String) {
    employeeOne(id: $id) {
      id
      staffId
      pin
      user {
        id
        username
        role
        firstName
        middleName
        lastName
        email
        phoneNumber
        createdDate
        profilePicUrl
      }
      organization {
        id
        name
      }
      locations {
        id
        name
        description
        logoUrl
        stationsEnabled
      }
      activeLocation {
        id
        name
        stationsEnabled
      }
      activeSession {
        location {
          id
          name
        }
        station {
          id
          name
        }
      }
      clockedIn
      role {
        id
        name
        description
        orgRoles
        orgPolicies
        orgAgreements
        orgPackages
        orgLocations
        orgDiscounts
        orgSettings
        orgService
        locPolicies
        locAgreements
        locPackages
        locServices
        locDiscounts
        locSettings
        locRooms
        locEmployees
        locProducts
        locRequests
        locTimeclock
        locDashboard
        locReports
        clients
        calendar
        catalog
        checkInQueue
        personalTimeClock
        employeeStations
      }
    }
  }
`;

export const GetEmployeePage = gql`
  query GetEmployeePage($locationId: String, $pagination: PaginationInput!) {
    employeePage(locationId: $locationId, pagination: $pagination) {
      items {
        id
        isActive
        user {
          id
          firstName
          middleName
          lastName
          email
          phoneNumber
          createdDate
          profilePicUrl
        }
        organization {
          id
          name
        }
      }
      totalRows
    }
  }
`;

export const GetEmployeeInfo = gql`
  query GetEmployeeInfo($id: String) {
    employeeOne(id: $id) {
      id
      staffId
      pin
      role {
        id
        name
      }
      user {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
        profilePicUrl
      }
      locations {
        id
        name
        description
        logoUrl
        stationsEnabled
      }
      stations {
        id
        name
      }
    }
  }
`;

export const checkEmployeePin = gql`
  query checkEmployeePin($pin: String!) {
    checkEmployeePin(pin: $pin)
  }
`;

export const GetEmployeesNameLoc = gql`
  query GetEmployeesNameLoc($locationId: String, $orgId: String) {
    employeeMany(locationId: $locationId, orgId: $orgId) {
      id
      user {
        id
        firstName
        lastName
      }
      locations {
        id
        name
        stationsEnabled
      }
    }
  }
`;

export const isRoleAssigned = gql`
  query isRoleAssigned($roleId: String!) {
    isRoleAssigned(roleId: $roleId)
  }
`;
